import type { Translated } from '@uefadigital/panenka';
import clsx from 'clsx';
import { memo, useMemo } from 'react';

import DrawTeam from '../Team';

import { useDrawOptions } from '@apps/draw/store';
import { useTranslateFn } from '@shared/Translate';
import type { Team } from '@shared-types/match.types';

import * as styles from './styles.module.scss';

const DrawKnockOutTeam = ({ teams }: { teams: Translated<Team>[] }) => {
  const {
    options: { calendarContext },
  } = useDrawOptions();
  const [team1, team2] = teams;
  const t = useTranslateFn();
  const fallbackName = t(window.isClub ? 'club' : 'team');
  const fallbackTeam = useMemo(() => ({ id: '', displayName: fallbackName }), [fallbackName]);

  return (
    <div className={clsx(styles.vsTeams, calendarContext && styles.vsTeamsCalendar)}>
      <DrawTeam team={team1 ?? fallbackTeam} isResult badgeSlot='suffix' alignment='right' />
      <span className={styles.vs}>{t('vs')}</span>
      <DrawTeam team={team2 ?? fallbackTeam} isResult alignment='left' />
    </div>
  );
};

export default memo(DrawKnockOutTeam);
